module.exports = __webpack_public_path__ + "img/icons-yrykb-dksq.5df86560.png";